import React, { useState, useEffect } from "react";
import { Divider } from "@mui/material";
import "./Stepper.scss";

function Stepper({ data }) {
  const [contentHeights, setContentHeights] = useState([]);

  useEffect(() => {
    const heights = [];
    data.forEach((entry, index) => {
      const content = document.getElementById(`json-value-content-${index}`);
      heights.push(content?.clientHeight);
    });
    setContentHeights(heights);
  }, [data]);
  return (
    <div className="stepper_main">
      {data.map((entry, index) => (
        <div key={index} className="stepper_steps">
          <div className="stepper_content">
            <div className="stepper_step_count">{index + 1}</div>
          </div>
          <div>
            <div className="stepper_content_div">
              <strong>{Object.values(entry)[0]}</strong>
            </div>
            <div id={`json-value-content-${index}`} className="step-paragraph-container">
              {
                Object.values(entry)[1].map(desc => <p>{`➡${desc}`}</p>)
              }
            </div>
            {/* <div>{entry[0]}</div> */}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Stepper;
